import { createContext } from 'react-router'
import type { Clerk } from '@clerk/types'

const clerkContext = createContext<Clerk | null>(null)

export default clerkContext
